import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const images = {
    background: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/background.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/background.jpg`,
        width: 1920,
        height: 1080,
    },
    overlay_landscape: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_landscape.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/overlay_landscape.webp`,
        width: 1920,
        height: 1080,
    },
    overlay_portrait: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_portrait.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/overlay_portrait.webp`,
        width: 1920,
        height: 1080,
    },
    overlay_square: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_square.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/overlay_square.webp`,
        width: 1920,
        height: 1080,
    },
    "caption/center": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/caption/center.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/caption/center.jpg`,
        width: 720,
        height: 1080,
    },
    "caption/left": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/caption/left.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/caption/left.jpg`,
        width: 600,
        height: 1080,
    },
    "caption/right": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/caption/right.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/caption/right.jpg`,
        width: 600,
        height: 1080,
    },
};
const greetingTemplate = {
    type: "typeOnGreeting",
    variant: "intro",
    secondsPerCharacter: 0.1,
    minimumMessageDisplayTimeSeconds: 3,
    showLogo: true,
    sharedMessageAssets: [
        {
            url: images["overlay_landscape"],
            style: {
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: "auto",
                transform: "scaleY(-1)",
            },
        },
        {
            url: images["overlay_landscape"],
            style: {
                position: "absolute",
                top: 0,
                width: "100%",
                height: "auto",
                transform: "scaleX(-1)",
            },
        },
    ],
};
export const inkyGuestBook = {
    version: 1,
    themeId: "inky-guest-book",
    name: "Inky Guest Book",
    endFadeDuration: 1,
    thumbnailFrame: 150,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/inky-guest-book.webp`,
    background: [
        {
            variant: "image",
            src: images["background"],
        },
    ],
    scenes: [
        {
            type: "inkyGuestBookIntro",
            durationSeconds: 8,
            variant: "intro",
            videoUrl: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/intro.mp4`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/intro.mp4`,
            },
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                colorFilter: "grayscale",
                startAtSeconds: 6.33,
                faceCollageSceneDurationSeconds: 11,
                entrance: {
                    variant: "zoom-in",
                },
            },
            title: {
                fontFamily: "Kristi",
                fontSize: 150,
                fontWeight: "medium",
                textColor: "#000",
            },
            subtitle: {
                fontFamily: "EB Garamond",
                fontSize: 60,
                fontWeight: "light",
                textColor: "#000",
            },
        },
        {
            ...greetingTemplate,
            variant: "intro",
        },
        {
            type: "clip-series-basic",
            showLogo: true,
            sceneBackground: {
                variant: "lottie",
                loop: false,
                aspectRatios: {
                    portrait: {
                        url: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_portrait_2.json`,
                        endFrameStillUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_portrait.webp`,
                    },
                    landscape: {
                        url: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_landscape_2.json`,
                        endFrameStillUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_landscape.webp`,
                    },
                    square: {
                        url: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_square_2.json`,
                        endFrameStillUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/overlay_square.webp`,
                    },
                },
            },
        },
        {
            ...greetingTemplate,
            variant: "outro",
        },
        {
            type: "inkyGuestBookIntro",
            durationSeconds: 11,
            videoUrl: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/outro.mp4`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/outro.mp4`,
            },
            variant: "outro",
            title: {
                fontFamily: "Kristi",
                fontSize: 150,
                fontWeight: "medium",
                textColor: "#000",
            },
            subtitle: {
                fontFamily: "EB Garamond",
                fontSize: 60,
                fontWeight: "light",
                textColor: "#000",
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0.1,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#555",
            fontFamily: "EB Garamond",
            fontWeight: "normal",
            fontSize: 96,
            leading: 1.1,
            tracking: 0.05,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "image-stretch",
                leftUrl: images["caption/left"],
                center: {
                    variant: "stretch-y-repeat-x",
                    url: images["caption/center"],
                },
                rightUrl: images["caption/right"],
                maxWidthPx: 600,
                textContainerStyleOverride: {
                    height: "18rem",
                    paddingLeft: "8rem",
                    paddingRight: "8rem",
                },
            },
            borderRadius: "0px",
            betweenTransition: {
                variant: "imageSequence",
                timing: { variant: "linear", durationSeconds: 1.5 },
                mask: {
                    // We use the common mask, since its the same, but we have a special overlay
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
                overlay: {
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/common-overlay/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/common-overlay/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Kristi",
                fontWeight: "medium",
                fontSize: 150,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "EB Garamond",
                fontWeight: "light",
                fontSize: 48,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 0.96,
            scaleMode: "aspect-bleed",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "imageSequence",
            timing: { variant: "linear", durationSeconds: 1.5 },
            mask: {
                // We use the common mask, since its the same, but we have a special overlay
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
            // This is not the common overlay; it's specific to inky-guest-book
            overlay: {
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/common-overlay/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/inky-guest-book/optimized/common-overlay/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
        },
    },
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name of Couple",
            defaultValue: "",
            placeholder: "Jessica & David",
            required: true,
            min: 1,
            max: 50,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "date",
            type: "date",
            label: "Wedding Date",
            defaultValue: "",
            placeholder: "Select a date",
            required: true,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
    ],
};
